import React from 'react';
import { BaseButton } from '@repo/common';

/**
 * @example
 * <PathfinderBottomToolbar onBack={handleBack} onNext={handleNext} />
 */
function PathfinderBottomToolbar({
  backLabel = 'Back',
  nextLabel = 'Next',
  onBack,
  onNext,
  nextDisabled = false,
  className = '',
}) {
  return (
    <div
      className={`w-full border-b border-grayscale-gray02 bg-grayscale-gray00 px-20 py-6 ${className}`}
    >
      <div className='mx-auto flex w-full max-w-[1180px] items-center justify-between gap-4'>
        <BaseButton
          type='text'
          size='xl'
          width='180px'
          hideIcon
          onClick={onBack}
          bgclass='bg-grayscale-gray01'
          borderclass='border-grayscale-gray01'
          textclass='text-grayscale-gray07'
          hoverclass='hover:bg-grayscale-gray02 hover:border-grayscale-gray02 hover:text-grayscale-gray07'
          activeclass='active:bg-grayscale-gray02 active:border-grayscale-gray02 active:text-grayscale-gray07'
        >
          {backLabel}
        </BaseButton>

        <BaseButton
          type='primary'
          size='xl'
          width='180px'
          hideIcon
          isDisabled={nextDisabled}
          onClick={onNext}
        >
          {nextLabel}
        </BaseButton>
      </div>
    </div>
  );
}

export default PathfinderBottomToolbar;
